/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Button, Panel, TableAdvanced, Text } from "vr-react-components";
import { getFormattedTime } from "../../utils/TimeUtils";
import { handleSetKeyboard } from "../../handlers/PrivateHandlers";
import { handleGoToJobRoom } from "../../handlers/JobRoomHandlers";

const CriticalJobsInfoPanel = ({ openedPanelDimension, onClose }) => {
    const currentRoom = useSelector((state) => state.room.history[0].ID);
    const highRisk = useSelector((state) => state[currentRoom].criticalJobsData["Critical Jobs Info High Risk"]);
    const potentialRisk = useSelector((state) => state[currentRoom].criticalJobsData["Critical Jobs Info Potential Risk"]);
    const noRisk = useSelector((state) => state[currentRoom].criticalJobsData["Critical Jobs Info No Risk"]);
    const canModify = useSelector((state) => state.private.device.canModify);

    const criticalJobsData = [...highRisk, ...potentialRisk, ...noRisk];

    return (
        <a-entity>
            <Text
                text="Critical Jobs Status"
                width={openedPanelDimension}
                sizeDecimal={30 / openedPanelDimension}
                baseline="top"
                position={`${-openedPanelDimension / 2 + openedPanelDimension * 0.05} ${openedPanelDimension / 2 - openedPanelDimension * 0.05
                    } 0`}
            />
            <Button
                text="Close"
                width={openedPanelDimension * 0.4}
                aframeClasses={canModify ? "collidable" : ""}
                height={openedPanelDimension * 0.1}
                onClickHandler={onClose}
                position={`${openedPanelDimension / 2 -
                    openedPanelDimension * 0.05 -
                    openedPanelDimension * 0.2
                    } ${-openedPanelDimension / 2 +
                    openedPanelDimension * 0.05 +
                    openedPanelDimension * 0.05
                    } 0.001`}
                type={Button.constants.primary}
                textSizeDecimal={40 / openedPanelDimension}
            />
            <Panel
                width={openedPanelDimension}
                height={openedPanelDimension * 0.7}
                aframeClasses={canModify ? "collidable" : ""}
                resize
            >
                <TableAdvanced
                    keyboardHandler={handleSetKeyboard}
                    aframeClasses={canModify ? "collidable" : ""}
                    search
                    data={[
                        ["Name", "Risk", "Workstation", "Workflow", "Scheduled Time"],
                        ...criticalJobsData.map((x) => [
                            x.name,
                            x.risk,
                            x.workstation.name,
                            x.workflow,
                            getFormattedTime(x.scheduledTime)]),
                    ]}
                    onRowClick={(position) => {
                        handleGoToJobRoom(criticalJobsData[position])
                    }}
                />
            </Panel>
        </a-entity>
    );
};

export default CriticalJobsInfoPanel;